import React from 'react';
import {useTranslation} from 'react-i18next';
import {CheckCircle, Prohibit, UserPlus, Users, Warning} from '../icons';
import {USAGE_STATE} from './portalUsageState';

// El estado de un cliente, pintado igual en las tres superficies. El mapa vive acá y no en cada
// pantalla: si el detalle dice "Activo" y el ranking dice "Sin actividad" para el mismo cliente,
// el usuario deja de creerle a las dos.
//
// Semántica del color, la del sistema: verde/ámbar es el semáforo de salud y el violeta es todo lo
// de IA — "invitado sin usar" va en violeta porque es la promesa del asistente todavía sin cobrar,
// no un problema.
const BY_STATE = {
    [USAGE_STATE.ACTIVE]: {tone: 'ok', Icon: CheckCircle, key: 'portal_usage.state_active', fallback: 'Activo'},
    [USAGE_STATE.DORMANT]: {tone: 'warn', Icon: Warning, key: 'portal_usage.state_dormant', fallback: 'Sin actividad'},
    // "Con acceso" y no "Invitado": este estado significa que el usuario YA aceptó la invitación
    // y nunca usó el portal. Decirle "invitado" mandaba a la agencia a reenviar una invitación que
    // el cliente ya había aceptado.
    [USAGE_STATE.INVITED_UNUSED]: {tone: 'ia', Icon: UserPlus, key: 'portal_usage.state_invited', fallback: 'Con acceso, sin usar'},
    [USAGE_STATE.NO_USERS]: {tone: 'muted', Icon: Users, key: 'portal_usage.state_no_users', fallback: 'Sin usuarios'},
    [USAGE_STATE.MODULE_OFF]: {tone: 'off', Icon: Prohibit, key: 'portal_usage.state_module_off', fallback: 'Portal apagado'},
};

/** La pastilla de estado. `state` desconocido o ausente → no renderiza nada (nunca inventa uno). */
export function PortalUsageBadge({state}) {
    const {t} = useTranslation();
    const config = BY_STATE[state];
    if (!config) return null;

    const {Icon} = config;
    return (
        <span className={`pu-badge -${config.tone}`}>
            <Icon size={13} weight="fill"/>
            {t(config.key, config.fallback)}
        </span>
    );
}

export default PortalUsageBadge;
